import * as R from 'ramda'

export default sku => {
  const productName = R.path(['productRef', 'name'], sku)
  const size = R.path(['spec', 'skuSizeRef', 'key'], sku)
  const color = R.path(['spec', 'skuColorRef', 'name'], sku)
  if (!productName) return ''
  return `${productName}_${color || ''}_${size || ''}`
}
